import PIXI from 'pixi.js';
import TimerManager from './TimerManager';
import Timer from './Timer';

export const TIMER = {
    TimerManager: new TimerManager(),
    Timer: Timer
};

// if(!PIXI.timerManager){
//   PIXI.timerManager = new TimerManager();
//
//   PIXI.timer = timer;
// }

